import classnames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import Grid from '@common/Listing/containers/Grid';
import '../styles/ListingTopInfo.scss';

export function ListingTopInfo({
    customClass,
    theme,
    isAlt2Listing
}) {
    const [block, BEMElement] = BEMBlock('listing-top-info');

    return (
        <div className={classnames(block, customClass)}>
            {
                !isAlt2Listing
                && (
                    <div className={BEMElement('toolbar')}>
                        <Grid
                            isPremium
                            customClass={BEMElement('grid')}
                            theme={theme}
                        />
                    </div>
                )
            }
        </div>
    );
}
